module.exports = __webpack_public_path__ + "static/media/Icon.4d908e10.svg";